import * as types from 'store/mutation-types'

const state = {
  publishModal: {
    open: false
  },
  builderSaveModal: {
    open: false
  },
  deleteCheckoutModal: {
    open: false
  },
  duplicateCheckoutModal: {
    open: false
  },
  sidebar: {
    open: false
  },
  unpublishCheckoutModal: {
    open: false
  },
  productSelectModal: {
    open: false
  },
  earlyRenewalOfferPickerModal: {
    open: false
  },
  productImageSelectModal: {
    open: false
  }
}

const getters = {

}

const mutations = {
  [types.TOGGLE_MODAL] (state, {modal, value}) {
    state[modal].open = value
  }
}

const actions = {
  [types.OPEN_DELETE_CHECKOUT_MODAL] ({ commit }) {
    commit(types.TOGGLE_MODAL, { modal: 'deleteCheckoutModal', value: true })
  },
  [types.CLOSE_DELETE_CHECKOUT_MODAL] ({ commit }) {
    commit(types.TOGGLE_MODAL, { modal: 'deleteCheckoutModal', value: false })
  },
  [types.OPEN_DUPLICATE_CHECKOUT_MODAL] ({ commit }) {
    commit(types.TOGGLE_MODAL, { modal: 'duplicateCheckoutModal', value: true })
  },
  [types.CLOSE_DUPLICATE_CHECKOUT_MODAL] ({ commit }) {
    commit(types.TOGGLE_MODAL, { modal: 'duplicateCheckoutModal', value: false })
  },
  [types.OPEN_PUBLISH_MODAL] ({ commit }) {
    commit(types.TOGGLE_MODAL, { modal: 'publishModal', value: true })
  },
  [types.CLOSE_PUBLISH_MODAL] ({ commit }) {
    commit(types.TOGGLE_MODAL, { modal: 'publishModal', value: false })
  },
  [types.OPEN_BUILDER_SAVE_MODAL] ({ commit }) {
    commit(types.TOGGLE_MODAL, { modal: 'builderSaveModal', value: true })
  },
  [types.CLOSE_BUILDER_SAVE_MODAL] ({ commit }) {
    commit(types.TOGGLE_MODAL, { modal: 'builderSaveModal', value: false })
  },
  [types.OPEN_SIDEBAR] ({ commit }) {
    commit(types.TOGGLE_MODAL, { modal: 'sidebar', value: true })
  },
  [types.CLOSE_SIDEBAR] ({ commit, rootState: { dashboard } }) {
    commit(types.TOGGLE_MODAL, { modal: 'sidebar', value: false })
    const id = dashboard.checkoutData?.id
    if (id) {
      let button = document.querySelector(`#checkout-${id}`)
        ? document.querySelector(`#checkout-${id}`)
        : document.querySelector(`#checkout-${id}-title`)
      if (button) {
        button.focus()
      }
    }
  },
  [types.OPEN_UNPUBLISH_CHECKOUT_MODAL] ({ commit }) {
    commit(types.TOGGLE_MODAL, { modal: 'unpublishCheckoutModal', value: true })
  },
  [types.CLOSE_UNPUBLISH_CHECKOUT_MODAL] ({ commit }) {
    commit(types.TOGGLE_MODAL, { modal: 'unpublishCheckoutModal', value: false })
  },
  [types.OPEN_PRODUCT_SELECT_MODAL] ({ commit }) {
    commit(types.TOGGLE_MODAL, { modal: 'productSelectModal', value: true })
  },
  [types.CLOSE_PRODUCT_SELECT_MODAL] ({ commit }) {
    commit(types.TOGGLE_MODAL, { modal: 'productSelectModal', value: false })
  },
  [types.OPEN_EARLY_RENEWAL_OFFER_PICKER_MODAL] ({ commit }) {
    commit(types.TOGGLE_MODAL, { modal: 'earlyRenewalOfferPickerModal', value: true })
  },
  [types.CLOSE_EARLY_RENEWAL_OFFER_PICKER_MODAL] ({ commit }) {
    commit(types.TOGGLE_MODAL, { modal: 'earlyRenewalOfferPickerModal', value: false })
  },
  [types.OPEN_PRODUCT_IMAGE_SELECT_MODAL] ({ commit }) {
    commit(types.TOGGLE_MODAL, { modal: 'productImageSelectModal', value: true })
  },
  [types.CLOSE_PRODUCT_IMAGE_SELECT_MODAL] ({ commit }) {
    commit(types.TOGGLE_MODAL, { modal: 'productImageSelectModal', value: false })
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
